import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('UserBo', UserBoData);

    UserBoData.$inject = ['Seller', 'User', 'PrincipalDetail', 'UserImpersonated'];

    /* @ngInject */
    function UserBoData(Seller, User, PrincipalDetail, UserImpersonated) {
        UserBo.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getOwnerEntityName: getOwnerEntityName,
            getSearchUserAutoComplete: getSearchUserAutoComplete,
        };

        function UserBo(userBoData) {
            if (!userBoData) {
                this.buildEmpty();
            } else {
                this.build(userBoData);
            }
        }

        return UserBo;

        /////////////////////

        function buildEmpty() {
            this.principalId = null;
            this.seller = new Seller();
            this.user = new User();
            this.unlockable = null;
            this.communitiesCga = null;
            this.impersonatedUser = null;
        }

        function build(userBoData) {
            this.seller = userBoData.seller && new Seller(userBoData.seller);
            this.user = new User(userBoData.user);
            this.principal = userBoData.principal && new PrincipalDetail(userBoData.principal);
            this.unlockable = userBoData.unlockable;
            this.communitiesCga = userBoData.communitiesCga || null;
            this.impersonatedUser =
                userBoData.user.impersonatedUser && new UserImpersonated(userBoData.user.impersonatedUser);
        }

        /**
         * Retourne le nom du fournisseur pour l'affichage dans la liste : SellerName (Identifiant)
         */
        function getOwnerEntityName() {
            var name = '';
            if (this.seller) {
                name = this.seller.getSellerNameWithId();
            } else if (this.principal) {
                name = this.principal.corporateName;
            }
            return name;
        }

        function getSearchUserAutoComplete() {
            var name = '';
            if (this.user) {
                name = this.user.getInfoForAutocompete();
            }
            return name;
        }
    }
})();
